import { createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "anchor fw-bolder mb-5" }, [
  /*#__PURE__*/_createVNode("a", { href: "#custom-option-content" }),
  /*#__PURE__*/_createTextVNode(" Custom option content ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, " You can customize the content of cascader node. ", -1)
const _hoisted_4 = { class: "rounded border p-10" }
const _hoisted_5 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_cascader = _resolveComponent("el-cascader")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_el_cascader, { options: _ctx.options }, {
        default: _withCtx(({ node, data }) => [
          _createVNode("span", null, _toDisplayString(data.label), 1),
          (!node.isLeaf)
            ? (_openBlock(), _createBlock("span", _hoisted_5, " (" + _toDisplayString(data.children.length) + ") ", 1))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["options"]),
      _createVNode(_component_CodeHighlighter, {
        "field-height": 400,
        lang: "html"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.code9), 1)
        ]),
        _: 1
      })
    ])
  ]))
}